import {
  Button,
  Modal,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  Portal,
  useDisclosure,
} from '@chakra-ui/react';
import { AddIcon, CloseIcon, PlayCircleFilledIcon } from '@sketchnote/icons';
import Tippy from '@tippyjs/react';
import { useState } from 'react';

import { Sprint, useAgileStore } from '../../store';
import { SprintModal } from './SprintModal';

function checkSprintIsRunning(sprints) {
  for (const sprint of sprints) {
    if (sprint.isSprintRunning === 1) {
      return true;
    }
  }
  return false;
}

function StartSprint({ sprint }: { sprint: Sprint }) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [sprintOpen, setSprintOpen] = useState(false);
  const { startSprint, sprints } = useAgileStore();

  const id = sprint._id;
  const itemSize = sprint.items.length;

  const handleSprintClose = () => {
    setSprintOpen(false);
  };

  const handleOpen = (e) => {
    e.stopPropagation();
    if (checkSprintIsRunning(sprints)) {
      onOpen();
    } else {
      handleSprintStart();
    }
  };
  const handleSprintStart = () => {
    // startSprint(id);
    setSprintOpen(true);
    onClose();
  };
  return (
    <>
      {itemSize === 0 ? (
        <Tippy content={<span>Add items to start sprint</span>}>
          <span onClick={(e) => e.stopPropagation()} className="inline-block mt-6">
            <PlayCircleFilledIcon fill="#878A92" />
          </span>
        </Tippy>
      ) : (
        <Tippy content={<span>Start sprint</span>}>
          <span onClick={handleOpen} className="inline-block mt-6">
            <PlayCircleFilledIcon fill="#254DDA" />
          </span>
        </Tippy>
      )}

      <Portal>
        <Modal isCentered isOpen={isOpen} onClose={onClose}>
          <ModalOverlay />
          <ModalContent
            style={{
              position: 'initial',
            }}
            className={` min-w-356 bg-white rounded-lg static`}
          >
            <div>
              <div className="p-24">
                <div className="flex justify-between mb-8">
                  <span className="text-primary-700 font-semibold text-xl">Are you sure?</span>
                  <button aria-label="close button" onClick={onClose}>
                    <CloseIcon className="text-gray-600 text-xs" />
                  </button>
                </div>

                <div className="w-full mb-20">
                  <label className="mb-8 block  text-sm text-gray-999 ">
                    Some sprints are already running. What would you like to do?
                  </label>
                </div>

                <div className="flex items-start flex-col gap-10  w-full">
                  {/* <button
                    className={` text-white border rounded-sm px-24 py-8  w-full ${
                      isSaving ? 'bg-blue-200' : 'bg-blue-500'
                    }`}
                    // onClick={handleSprint}
                    disabled={isSaving}
                  >
                    End running sprints, Start this sprint
                  </button> */}

                  <button
                    onClick={handleSprintStart}
                    className=" bg-blue-500 text-white border rounded-sm px-24 py-8 mr-8 w-full"
                  >
                    Start this sprint simultaneously
                  </button>
                  <button
                    onClick={onClose}
                    className="border-blue-500 text-blue-500 border rounded-sm px-24 py-8 mr-8 w-full"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
            <ModalCloseButton />
          </ModalContent>
        </Modal>
      </Portal>
      <Portal>
        <Modal isCentered isOpen={sprintOpen} onClose={handleSprintClose}>
          <ModalOverlay />
          <ModalContent
            style={{
              position: 'initial',
            }}
            className={` min-w-356 bg-white rounded-lg static`}
          >
            <SprintModal onClose={handleSprintClose} data={sprint} id={id} />
          </ModalContent>
        </Modal>
      </Portal>
    </>
  );
}

export default StartSprint;
